"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = createUseScroll;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function createUseScroll(updateScroll, start, stop, updateLocation) {
  return function (createHistory) {
    return function () {
      var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
      var shouldUpdateScroll = options.shouldUpdateScroll;

      var historyOptions = _objectWithoutProperties(options, ["shouldUpdateScroll"]);

      var history = createHistory(historyOptions);

      var numListeners = 0;

      function checkStart() {
        if (++numListeners === 1 && start) {
          start(history);
        }
      }

      function checkStop() {
        if (--numListeners === 0 && stop) {
          stop();
        }
      }

      function listenBefore(hook) {
        checkStart();
        var unlisten = history.listenBefore(hook);

        return function () {
          unlisten();
          checkStop();
        };
      }

      var oldLocation = undefined;
      var listeners = [],
          currentLocation = undefined,
          unlisten = undefined;

      function onChange(location) {
        oldLocation = currentLocation;
        currentLocation = location;

        listeners.forEach(function (listener) {
          return listener(location);
        });

        // useStandardScroll needs the new location even when not updating the
        // scroll position, to update the current key.
        if (updateLocation) {
          updateLocation(location);
        }

        if (!shouldUpdateScroll || shouldUpdateScroll(oldLocation, currentLocation)) {
          updateScroll(location);
        }
      }

      function listen(listener) {
        checkStart();

        if (listeners.length === 0) {
          unlisten = history.listen(onChange);
        }

        // Add the listener to the list afterward so we can manage calling it
        // initially with the current location.
        listeners.push(listener);
        listener(currentLocation);

        return function () {
          listeners = listeners.filter(function (item) {
            return item !== listener;
          });
          if (listeners.length === 0) {
            unlisten();
          }

          checkStop();
        };
      }

      return _extends({}, history, {
        listenBefore: listenBefore,
        listen: listen
      });
    };
  };
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/scroll-behavior/lib/utils/createUseScroll.js
// module id = 1088
// module chunks = 0